import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useGlobalVideo } from '../contexts/VideoContext';
import { useTranslation } from '../contexts/TranslationContext';
import VideoModal from './VideoModal';

interface VideoProviderProps {
  children: React.ReactNode;
  videoUrl?: string;
  videoTitle?: string;
}

const VideoProvider: React.FC<VideoProviderProps> = ({ children, videoUrl, videoTitle }) => {
  const [open, setOpen] = useState(false);
  const { setVideoFunction } = useGlobalVideo();
  const { t } = useTranslation();

  useEffect(() => {
    if (videoUrl) {
      setVideoFunction(() => setOpen(true));
    }
  }, [videoUrl, setVideoFunction]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  // Translate the title if it's a translation key
  const translatedTitle = useMemo(
    () => (videoTitle?.startsWith('video.') ? t(videoTitle) : videoTitle),
    [videoTitle, t],
  );

  return (
    <>
      {children}
      {videoUrl && (
        <VideoModal
          open={open}
          onClose={handleClose}
          videoUrl={videoUrl}
          title={translatedTitle}
        />
      )}
    </>
  );
};

export default VideoProvider;

